import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  value: PropTypes.shape({
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    rangeType: PropTypes.string
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }))
};

const defaultProps = {
  options: [
    { label: 'Hoy', value: 'TODAY' },
    { label: 'Ayer', value: 'YESTERDAY' },
    { label: 'Semana pasada', value: 'LAST_WEEK' },
    { label: 'Últimos 7 días', value: 'LAST_7_DAYS' },
    { label: 'Mes pasado', value: 'LAST_MONTH' },
    { label: 'Mes a la fecha', value: 'MONTH' }
  ]
};

const DateRangeFilterLabel = ({ value, fieldName, options }) => {
  if (!value) return null;
  
  const fieldLabel = window.I18n ? 
    I18n.t(`activerecord.attributes.${fieldName}`) : 
    fieldName;
  
  let label;
  
  if (value.rangeType && value.rangeType !== 'CUSTOM_RANGE') {
    const option = options.find(opt => opt.value === value.rangeType);
    if (option) {
      label = `${fieldLabel}: ${option.label}`;
    }
  } 
  else {
    const startDate = new Date(value.startDate).toLocaleDateString();
    const endDate = new Date(value.endDate).toLocaleDateString();
    
    if (value.rangeType === 'CUSTOM_RANGE') {
      label = `${fieldLabel}: Rango personalizado (${startDate} - ${endDate})`;
    } else {
      label = `${fieldLabel}: ${startDate} - ${endDate}`;
    }
  }
  
  return label;
};

DateRangeFilterLabel.propTypes = propTypes;
DateRangeFilterLabel.defaultProps = defaultProps;

export default DateRangeFilterLabel; 